import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from 'store/modules/layout'
import { localized } from 'decorators'
import { userManager } from 'auth/userManager'

class LogoutPage extends Component {
  componentDidMount (event) {
    this.props.showOverlay({ overlayMessage: this.props.localize('common.loggingOut')})
    userManager.signoutRedirect()
  }

  render () {
    return <div />
  }
}

const mapDispatchToProps = {
  showOverlay: actionCreators.showOverlay
}
export default connect(null, mapDispatchToProps)(localized(LogoutPage))
